import { Text, Title } from "@clipboard-health/ui-components";
import { Box, DialogContent, Stack } from "@mui/material";
import { isIosPlatform } from "@src/appV2/lib";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";

interface ScanInstructionsStageProps {
  onStartScan: () => void;
  onCancel: () => void;
  onUnableToScan: () => void;
  disableSkip?: boolean;
}

function TipItem({ number, children }: { number: number; children: string }) {
  return (
    <Stack direction="row" spacing={3} alignItems="flex-start">
      <Text
        bold
        variant="body2"
        sx={(theme) => ({
          color: theme.palette.primary.light,
          width: 17,
          textAlign: "center",
          flexShrink: 0,
        })}
      >
        {number}
      </Text>
      <Text variant="body2" sx={{ textAlign: "left" }}>
        {children}
      </Text>
    </Stack>
  );
}

export function ScanInstructionsStage(props: ScanInstructionsStageProps) {
  const { onStartScan, onCancel, onUnableToScan, disableSkip } = props;

  const phonePosition = isIosPlatform() ? "the top" : "the back center";

  return (
    <>
      <DialogContent sx={{ paddingX: 5 }}>
        <Stack spacing={6} alignItems="center" sx={{ textAlign: "center" }}>
          <Title variant="h3" component="h1">
            Trouble scanning?
          </Title>

          <Text
            variant="body1"
            sx={(theme) => ({
              color: theme.palette.text.secondary,
            })}
          >
            If you&apos;re having trouble scanning the NFC poster, here are some things you can try:
          </Text>

          <Box
            sx={(theme) => ({
              backgroundColor: theme.palette.background.default,
              border: `1px solid ${theme.palette.divider}`,
              borderRadius: theme.spacing(4),
              padding: theme.spacing(4),
              width: "100%",
            })}
          >
            <Stack spacing={3}>
              <TipItem number={1}>Poor connection? Try connecting to Wi-Fi.</TipItem>
              <TipItem number={2}>Try removing your phone case.</TipItem>
              <TipItem number={3}>
                {`Hold ${phonePosition} of your phone within 1 inch of the rectangle on the poster.`}
              </TipItem>
            </Stack>
          </Box>
        </Stack>
      </DialogContent>

      <DialogFooter
        orientation="vertical"
        closeButtonAriaLabel="Cancel"
        onClose={() => {
          onCancel();
        }}
      >
        <Button
          fullWidth
          variant="contained"
          size="large"
          onClick={() => {
            onStartScan();
          }}
        >
          Try scan again
        </Button>

        {!disableSkip && (
          <Button
            fullWidth
            variant="outlined"
            size="large"
            onClick={() => {
              onUnableToScan();
            }}
          >
            Unable to scan the poster
          </Button>
        )}
      </DialogFooter>
    </>
  );
}
